import React, { useEffect, useState } from 'react'
import CustomSecondPopUp from './CustomSecondPopUp'
import { useTranslate } from './TranslationText';
import { getAllOldHorsesForOwner, updateOldHorseStatus } from '../pages/sharedAPI/userApis';
import NewActionButton from './ActionButtons/NewActionButton';
import NetaqInput from './NetaqInput';
import { formatDate } from '../helper/formatDate';
import HorsesAboveThirty from './HorsesAboveThirty';

export default function OldHorsesDialog({ toast, showNow = false, setShowHorsesPop = () => { } }) {
    const [oldHorsesList, setoldHorsesList] = useState([]);
    const { translate } = useTranslate();
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const [showConfirmationMsg, setShowConfirmationMsg] = useState(false);
    const [showFirstModal, setShowFirstModal] = useState(true);
    let firstPopUpCloseFunction = () => { };

    useEffect(() => {
        if (userProfile?.showOldHorseAgeModal == true || showNow == true)
            getAllOldHorsesForOwner().then(res => {
                setoldHorsesList(res)
            })
    }, []);

    function takeAction(isDead = true, id) {
        setoldHorsesList((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, isDead } : item
            )
        );
    }

    function setDateOfBirth(id, date) {
        setoldHorsesList((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, dateOfDeath: formatDate(date) } : item
            )
        );
    }

    function validateForm(closrFirstpopUp) {
        firstPopUpCloseFunction = closrFirstpopUp;
        let hasError = false;
        for (let i = 0; i < oldHorsesList.length; i++) {
            const item = oldHorsesList[i];
            if (item?.isDead == null) {
                toast.error(translate('web.pleaseSelectOption', 'Action Required On Horse') + " " + item?.registerNumber + " - " + item?.name);
                hasError = true;
                break;
            }
            if (item?.isDead === true && !item?.dateOfDeath) {
                toast.error(
                    translate('web.pleaseEnterDeathDate', 'Date of Death') + " (" + item?.registerNumber + " - " + item?.name + ")"
                );
                hasError = true;
                break;
            }
        }
        if (hasError == false) {
            setShowConfirmationMsg(true);
        }
    }

    function submitForm(closePopup) {
        const horseList = oldHorsesList.map((item) => ({
            id: item?.id,
            isAlive: !item?.isDead,
            deathDate: item?.dateOfDeath
        }))
        updateOldHorseStatus(horseList).then(res => {
            if (res?.responseCode == "200") {
                toast.success(translate('web.dataSavedSuccessfully', 'Data Saved Successfully'));
                firstPopUpCloseFunction?.();
                setShowFirstModal(false);
                closePopup();
                setShowHorsesPop(false);
                setShowConfirmationMsg(false);
            }
            if (res?.responseCode == "100") {
                toast.error(translate(res?.responseText, res?.responseText));

            }
        })
    }


    return (
        <>
            {(userProfile?.showOldHorseAgeModal || showNow) &&
                <>
                    {
                        <CustomSecondPopUp
                            key={'firstPopUp'}
                            title={translate('web.oldHorsesDesc', 'Check Horses List')}
                            closePopUp={showNow}
                            closeOnEscape={false}
                            onClose={() => setShowHorsesPop(false)}
                            autoCloseOnSave={false}
                            open={(oldHorsesList.length > 0 && showFirstModal) || showNow}
                            onSave={oldHorsesList.length > 0 ? (closePopup) => validateForm(closePopup) : null}
                            children={<>
                                <HorsesAboveThirty isEdit={true} oldHorsesList={oldHorsesList} setDateOfBirth={setDateOfBirth} takeAction={takeAction} key={'any'} />
                            </>}

                        />
                    }
                </>}
            <CustomSecondPopUp
                key={'confirmation'}
                title={translate('web.areYouSure', 'Are You Sure?')}
                open={showConfirmationMsg}
                onClose={() => setShowConfirmationMsg(false)}
                onSave={(closePopup) => submitForm(closePopup)}
                isYesNoDialog
                children={<>
                    <HorsesAboveThirty isEdit={false} oldHorsesList={oldHorsesList} setDateOfBirth={setDateOfBirth} takeAction={takeAction} key={'any'} />
                </>}
            />
        </>
    )
}
